import type {
	ChatMessage,
	ChatResponse,
	ChatThread,
	ChatThreadWithMessages,
	CreateChatThreadParams,
	SendChatMessageParams,
} from "@/api/chatApi";
import {
	createChatThread,
	deleteChatThread,
	getChatThread,
	listChatThreads,
	sendChatMessage,
	updateChatThread,
} from "@/api/chatApi";

/**
 * Thin service layer for all chat-related API interactions.
 *
 * This keeps the feature code (`hooks`, `controllers`, `components`)
 * from depending directly on the low-level API client.
 */
export const chatService = {
	sendMessage: (params: SendChatMessageParams) => sendChatMessage(params),
	listThreads: (params?: { workspaceId?: string | null; graphId?: string | null }) =>
		listChatThreads(params ?? undefined),
	getThread: (threadId: string) => getChatThread(threadId),
	createThread: (params: CreateChatThreadParams) => createChatThread(params),
	updateThread: (threadId: string, params: { title?: string | null }) => updateChatThread(threadId, params),
	deleteThread: (threadId: string) => deleteChatThread(threadId),
};

export type {
	ChatMessage,
	ChatResponse,
	ChatThread,
	ChatThreadWithMessages,
	CreateChatThreadParams,
	SendChatMessageParams,
};
